/*
* ExternalKeys
* */

// export const LOCAL_MODE = true;
export const LOCAL_MODE = false;
// export const DEVELOPMENT_MODE = true;
export const DEVELOPMENT_MODE = false;
